import type * as Core from "@zeller-public/payments-sdk-core";
import { jwtDecode } from "jwt-decode";
import { safe, unwrap } from "pb.safe";

import type { tags } from "../tags";

export function tags_fromRequest(request: Core.Protocol.Request_Query) {
	const { headers, query } = request;

	const customerId = unwrap(
		safe(() => {
			const claims = jwtDecode(headers.authAccessToken ?? "");
			if ("https://identity.myzeller.com/customerUuid" in claims) {
				return claims["https://identity.myzeller.com/customerUuid"] as string;
			}
			return undefined;
		}),
	);

	return {
		"zeller.request.deviceId": headers.deviceId,
		"zeller.request.deviceModel": headers.deviceModel,
		"zeller.request.deviceSerial": headers.deviceSerial,

		"zeller.request.customerId": customerId ?? "ERROR",

		"zeller.request.queryType": query.$type,

		"zeller.request.fullscreen":
			"fullscreen" in query ? query.fullscreen : undefined,
		"zeller.request.theme": "theme" in query ? query.theme : undefined,
		"zeller.request.terminalContact":
			"terminalContact" in query ? query.terminalContact : undefined,
		"zeller.request.terminalReceipt":
			"terminalReceipt" in query ? query.terminalReceipt : undefined,
		"zeller.request.terminalReceiptPrint":
			"terminalReceiptPrint" in query ? query.terminalReceiptPrint : undefined,
		"zeller.request.terminalNote":
			"terminalNote" in query ? query.terminalNote : undefined,
		"zeller.request.unattended":
			"unattended" in query ? query.unattended : undefined,
		"zeller.request.virtualTerminal":
			"virtualTerminal" in query ? query.virtualTerminal : undefined,
	} satisfies tags.Tags;
}
